import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import styles from './viewExternalService.module.css';
import { useBreadcrumbs } from '../../../../components/ui/breadcrumps/breadcrumbsContext';
import { useCRUD } from '../../../../api/crud';
import { EXTERNAL_SERVICES_ENDPOINT } from '../../../../consts';

export const ViewExternalService = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const { setOverride } = useBreadcrumbs();
  const { get } = useCRUD(EXTERNAL_SERVICES_ENDPOINT);

  const basePath = `/service/external-services/${id}`;

  useEffect(() => {
    const fetchExternalService = async () => {
      if (id) {
        const response = await get(id);
        setOverride(basePath, response?.data ? response.data.name : id);
      }
    };

    window.addEventListener('externalServiceUpdated', fetchExternalService);
    fetchExternalService();
    return () => {
      window.removeEventListener('externalServiceUpdated', fetchExternalService);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const visibleTabs = [
    { key: 'basic', path: basePath },
    { key: 'jobs', path: `${basePath}/jobs` },
  ];

  const tabValue = location.pathname.includes('/jobs') ? 1 : 0;

  return (
    <Box className={styles.container}>
      <Tabs className="subTabs" value={tabValue} variant="scrollable" scrollButtons="auto">
        {visibleTabs.map((tab) => {
          const labels: Record<string, string> = {
            basic: t('Basic Information'),
            jobs: t('Assigned jobs'),
          };
          return <Tab key={tab.key} label={labels[tab.key]} onClick={() => navigate(tab.path)} />;
        })}
      </Tabs>
      <Box className={styles.content}>
        <Outlet />
      </Box>
    </Box>
  );
};
